import * as React from 'react';
import Desktop from './Desktop';
import Mobile from './Mobile';

export interface ComponentWrapperProps<ComponentPropsType> {
  desktopProps: ComponentPropsType;
  mobileProps: ComponentPropsType;
  mobileType?: React.ComponentType<ComponentPropsType>;
  type: React.ComponentType<ComponentPropsType>;
}

/* eslint-disable-next-line react/prefer-stateless-function */
export default class ComponentWrapper<ComponentProps = {}> extends React.Component<
  ComponentWrapperProps<ComponentProps>
> {
  render() {
    const { type, desktopProps, mobileType, mobileProps } = this.props;
    return (
      <>
        <Desktop>{React.createElement(type, desktopProps)}</Desktop>
        <Mobile>{React.createElement(mobileType || type, mobileProps)}</Mobile>
      </>
    );
  }
}
